import { FaInfoCircle } from "react-icons/fa";
import styled from "styled-components";

export const TableContainer = styled.div`
  width: 100%;
  margin-bottom: 50px;
  background: #f8f8f8;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);   
  max-height: 500px;
  overflow-y: auto;
`;

export const Sidebar = styled.div<{ open: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  width: 300px;
  height: 100%;
  background: white;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);
  padding: 20px;
  transform: ${({ open }) => (open ? "translateX(0)" : "translateX(100%)")};
  transition: transform 0.3s ease-in-out;
`;

export const Input = styled.input`
  width: 95%;
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
`;

export const SelectAddherense = styled.select`
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const Thead = styled.thead`
  background-color: #ff56412e;
  color: #333;
`;

export const Th = styled.th`
  padding: 12px;
  text-align: left;
  border-bottom: 2px solid #ddd;
`;

export const Tbody = styled.tbody`
  background: white;
`;

export const Tr = styled.tr`
  &:nth-child(even) {
    background: #f4f4f4;
  }
`;

export const Td = styled.td<{ error?: boolean }>`
  padding: 10px;
  border-bottom: 1px solid #ddd;
  color: ${({ error }) => (error ? "red" : "#333")};
  font-weight: ${({ error }) => (error ? "bold" : "normal")};
`;

export const ActionIcons = styled.div`
  display: flex;
  gap: 10px;
  cursor: pointer;

  svg {
    color: #666;
    &:hover {
      color: #333;
    }
  }
`;

export const ErrorIcon = styled(FaInfoCircle)`
  color: red;
`;

export const SaveButton = styled.button`
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    background-color: #218838;
  }
`;

export const CloseButton = styled.button`
  padding: 10px 20px;
  margin-bottom: 0;
  background-color:rgb(208, 55, 50);
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    background-color:rgb(136, 33, 33);
  }
`;